import types from '../types'

const addResponse = (response, modeId, addBoth, isOutbound) => ({
  type: types.RESPONSE_ADD,
  payload: response,
  mode: modeId,
  addBoth,
  isOutbound,
})

const replaceResponse = (response, modeId, isOutbound) => ({
  type: types.RESPONSE_REPLACE,
  modeId,
  response,
  isOutbound,
})

const replaceEntireResponse = (response, modeId) => ({
  type: types.RESPONSE_REPLACE_ALL,
  modeId,
  response,
})

const updateDetails = (response, modeId, detailsLink, oItinId, iItinId) => ({
  type: types.DETAILS_UPDATE,
  response,
  modeId,
  detailsLink,
  oItinId,
  iItinId,
})

const updateDetailsFailed = (detailsLink) => ({
  type: types.DETAILS_UPDATE_FAILED,
  detailsLink,
})

const reapplyDetailsLinks = (modeId, detailsLinks) => ({
  type: types.DETAILS_REAPPLY,
  modeId,
  detailsLinks,
})


const searchFailed = (modeId) => ({
  type: types.RESPONSE_SEARCH_FAILED,
  modeId,
})

const logPerformSearch = () => ({
  type: types.LOG_PERFORM_SEARCH,
})

const loadingResponses = () => ({
  type: types.RESPONSES_LOADING,
})

const changingTime = (modeId, isOutbound, newDateTime) => ({
  type: types.TIME_CHANGE,
  modeId,
  isOutbound,
  newDateTime,
})

const changingFerryType = (modeId, ferryType) => ({
  type: types.FERRY_TYPE_CHANGE,
  modeId,
  ferryType,
})

export default {
  addResponse,
  replaceResponse,
  replaceEntireResponse,
  updateDetails,
  logPerformSearch,
  loadingResponses,
  searchFailed,
  changingTime,
  changingFerryType,
  updateDetailsFailed,
  reapplyDetailsLinks,
}
